import 'react-native-gesture-handler';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';

import {createBrowserApp } from '@react-navigation/web'
import {Platform} from 'react-native'

import AirFreightForm from './src/pages/order/AirFreightForm'
import ContactForm from './src/pages/order/ContactForm'
import VehicleForm from './src/pages/order/VehicleForm'
import ROROForm from './src/pages/order/ROROForm'
import ContainerForm from './src/pages/order/ContainerForm'
import LandingForm from './src/pages/order/LandingForm'

import * as Linking from 'expo-linking'

//import OrderComplete from './src/pages/order/OrderComplete'


import Constants from 'expo-constants';
import * as Notifications from 'expo-notifications';
import * as Permissions from 'expo-permissions';
import React, { useState, useEffect, useRef } from 'react';
import { Text, View, Button } from 'react-native';

import * as myEPT from './assets/myEPT.json'
import { createAppContainer } from 'react-navigation';


const Tab = createBottomTabNavigator();
const Stack = createStackNavigator();



/*const App = Platform.select({
  web: config => createBrowserApp(config, {history :'hash'}),
  default: config => createAppContainer(config)
})*/

const prefix = Linking.makeUrl('/')

console.log(prefix)
const linking = {
  prefixes: [prefix],
  config: {
    screens: {
      Container: "Container Form",
      Vehicle: "Vehicle Form",
      Contact: "Contact Form",
      RORO: "RORO Form",
      AirFreightForm: "AirFreight",
    }
  },
};

function App() {
  return (
    <NavigationContainer linking={linking} >
      <Stack.Navigator linking={linking}>
        <Stack.Screen name="Landing Form" component={LandingForm} options={{ title: ' ' }}/>
        <Stack.Screen name="Container Form" component={ContainerForm} options={{ title: ' ' }}/>
        <Stack.Screen name="Vehicle Form" component={VehicleForm} options={{ title: ' ' }}/>
        {/*<Stack.Screen name="Order Complete" component={OrderComplete} />*/}
        <Stack.Screen name="Contact Form" component={ContactForm} options={{ title: ' ' }}/>
        <Stack.Screen name="RORO Form" component={ROROForm} options={{ title: ' ' }}/>
        <Stack.Screen name="AirFreight" component={AirFreightForm} options={{ title: ' '}}/>

        
        

      </Stack.Navigator>
    </NavigationContainer>
  );
}




export default App;